// Foydalanuvchining roli va loginiga qarab menyuni hisoblash.
// Bu yerdagi funksiyalar Sidebar, Login va route middleware uchun umumiy —
// menyuda ko'rinmaydigan sahifaga URL orqali ham kirib bo'lmasligi shu orqali ta'minlanadi.

import { exportMenu } from './menu'
import { exportInfoMenu } from './infoMenu'
import { exportAnalyticMenu } from './analyticMenu'
import { canSeeFakt } from 'helpers/helpers'

// Ruxsat berilgan loginlar uchun alohida ko'rsatiladigan Fakt bo'limi
const FAKT_MENU_ITEM = {
	url: "/fakt",
	i18n: "FAKT",
	icon: "uil-chart-line",
	active: false,
}

// Menyu (va uning ichki bo'limlari) url'lari ro'yxati
function urlsOf(items) {
	const urls = []
	for (const item of items) {
		if (item.url && item.url !== '#') urls.push(item.url)
		for (const child of item.children || []) {
			if (child.url && child.url !== '#') urls.push(child.url)
		}
	}
	return urls
}

// Umuman menyularda uchraydigan barcha sahifalar — ular ruxsat bo'yicha tekshiriladi
const ALL_MENU_URLS = [
	...new Set([
		...urlsOf(exportMenu),
		...urlsOf(exportInfoMenu),
		...urlsOf(exportAnalyticMenu),
		FAKT_MENU_ITEM.url,
	]),
]

// Sahifa shu menyu bo'limiga tegishlimi.
// Oddiy startsWith yaramaydi: "/pos-full" sahifasida "/pos" ham mos kelib,
// bir vaqtda ikkita bo'lim aktiv bo'lib qolardi.
export const matchPath = (path, prefix) => path === prefix || path.startsWith(prefix + '/')

// Joriy foydalanuvchi ko'radigan menyu
export function getVisibleMenu() {
	const role = localStorage.getItem('role')
	const authorities = JSON.parse(localStorage.getItem('authorities') || '[]')
	const isManager = Array.isArray(authorities) && authorities.includes('ROLE_MANAGER')

	let base = exportMenu
	if (role === 'ROLE_INFO') base = exportInfoMenu
	if (role === 'ROLE_ANALYTIC') base = exportAnalyticMenu

	// ROLE_MANAGER faqat adminOnly bo'lmagan bo'limlarni ko'radi
	let items = base.filter(item => !isManager || !item.adminOnly)

	// Menyuda Fakt yo'q bo'lsa-yu, login ruxsat etilgan bo'lsa — qo'shib qo'yamiz
	if (canSeeFakt() && !urlsOf(items).includes(FAKT_MENU_ITEM.url)) {
		items = [...items, { ...FAKT_MENU_ITEM }]
	}

	return items
}

// Login qilgandan keyin ochiladigan birinchi sahifa
export function getFirstMenuUrl() {
	return urlsOf(getVisibleMenu())[0] || '/login'
}

// Sahifa joriy foydalanuvchi uchun ochiqmi?
// Menyuga umuman aloqasi yo'q sahifalar (ichki/qo'shimcha sahifalar) tekshirilmaydi.
export function isMenuPathAllowed(path) {
	const matched = ALL_MENU_URLS.filter(url => matchPath(path, url))
	if (matched.length === 0) return true

	const visibleUrls = urlsOf(getVisibleMenu())
	return matched.some(url => visibleUrls.includes(url))
}
